import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { PrivacyNoticeDataProvider } from "../../data-provider/privacy-notice.dp";

let UserPrivacyNoticeComponent = {
    selector: "vcUserPrivacyNotice",
    templateUrl:
        "/angular/components/privacy/user-privacy-notice.component.html",
    bindings: {
        privacyNotice: "=?",
    },
    controller: class UserPrivacyNoticeController {
        // * bindings for typescript compiler *
        public privacyNotice?: any;
        // ************************************

        private dialog: DialogUtils;
        private $cookies: any;
        private toast: ToastUtils;
        private dataProvider: PrivacyNoticeDataProvider;

        constructor(
            $cookies: any,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            PrivacyNoticeDataProvider: PrivacyNoticeDataProvider
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.dataProvider = PrivacyNoticeDataProvider;
            this.$cookies = $cookies;
        }

        $onInit() {
            if (!this.privacyNotice) {
                this.dataProvider.pending().then((privacyNotice) => {
                    this.privacyNotice = privacyNotice;
                });
            }
        }

        acknowledge(privacyNotice): void {
            this.$cookies.put("privacyNotice", "acknowledged");

            this.dataProvider.acknowledge(privacyNotice);

            this.dialog.hide();

            this.toast.success(
                'You have acknowledged "' + privacyNotice.pnheader + '"'
            );
        }

        decline(privacyNotice): void {
            this.$cookies.put("privacyNotice", "declined");
            this.dialog.hide();
            this.toast.success(
                'You have declined "' + privacyNotice.pnheader + '"'
            );
        }
    },
};

angular
    .module("privacy")
    .component(UserPrivacyNoticeComponent.selector, UserPrivacyNoticeComponent);
